/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ListNftModal_MetadataAccount = {
    readonly id: string;
    readonly mint: unknown;
    readonly nft: {
        readonly creatorId: string;
    };
    readonly tags: ReadonlyArray<string>;
    readonly " $refType": "ListNftModal_MetadataAccount";
};
export type ListNftModal_MetadataAccount$data = ListNftModal_MetadataAccount;
export type ListNftModal_MetadataAccount$key = {
    readonly " $data"?: ListNftModal_MetadataAccount$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListNftModal_MetadataAccount">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListNftModal_MetadataAccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mint",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftExpress",
      "kind": "LinkedField",
      "name": "nft",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creatorId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    }
  ],
  "type": "MetadataAccount",
  "abstractKey": null
};
(node as any).hash = '785bc3d59bd3c5a7d829f97bfd228ba4';
export default node;
